<template>
  <div class="content-wrapper">
    <app-breadcrumb
        :page-title="pageTitle"
        :directory="$t('datatables')"
        :icon="'grid'"
    />
    <app-table :id="tableId" :options="options" @action="getListAction"/>
    <template v-if="assignToUserModal">
      <app-modal
          :modal-id="assignToUserModalId"
          modal-alignment="top"
          modal-size="default"
          @close-modal="closeModal(assignToUserModalId)"
      >
        <template slot="header">
          <h5 class="modal-title">{{ $t("Assign to user") }}</h5>
          <button
              type="button"
              class="close outline-none"
              data-dismiss="modal"
              aria-label="Close">
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
          </button>
        </template>
        <template slot="body">
          <div class="card card-with-search border-0 card-with-shadow">
            <div class="form-group row align-items-center ml-sm-2">

              <div class="form-group">
                <label>{{ $t("Select user to assign screening") }}</label>
                <app-input
                    type="select"
                    :placeholder="$t('select_user')"
                    :list="users"
                    v-model="select_user"
                    :required="true"
                />
                <div class="mt-2 d-flex col-12 justify-content-end align-items-center">
                  <button @click.prevent="assignToUser" class="btn btn-success mr-5">Save</button>
                </div>
              </div>


              </div>
            </div>
        </template>
        <template slot="footer">
          <button
              type="button"
              class="btn btn-primary mr-2"
              data-dismiss="modal"
              @click="closeModal(assignToUserModalId)">
            {{ $t("Cancel") }}
          </button>
        </template>
      </app-modal>
    </template>

    <template v-if="screeningUpdateModal">
    <app-modal
        :modal-id="screeningUpdateModalId"
        modal-alignment="top"
        modal-size="large"
        @close-modal="closeModal(screeningUpdateModalId)"
    >
      <template slot="header">
        <h5 class="modal-title">{{ $t("Update Screening Information") }}</h5>
        <button
            type="button"
            class="close outline-none"
            data-dismiss="modal"
            aria-label="Close">
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
        </button>
      </template>
      <template slot="body">
        <div class="card card-with-search border-0 card-with-shadow">
          <div class="form-group row align-items-center ml-sm-2">
            <label class="col-sm-2 mb-sm-0">Select Screening Creation Date</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="date"
                       v-model="screening.created_at"
                       placeholder="Select Date"
            />
            <label class="col-sm-2 mb-sm-0">Select Screening Date</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="date"
                       v-model="screening.start_date"
                       placeholder="Select Date"
            />
            <!-- <label class="col-sm-2 mb-sm-0">Select Screening Time</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="time"
                       v-model="screening.time"
                       placeholder="Select Time"
            /> -->
            <label class="col-sm-2 mb-sm-0">Select Deployment Date</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="date"
                       v-model="screening.deployment_date"
                       placeholder="Select Deployment Date"
            />
            <label class="col-sm-2 mb-sm-0">Select Limited Screening Completion Date</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="date"
                       v-model="screening.limited_screening_due_date"
                       placeholder="Select Limited Screening Completion Date"
            />
            <label class="col-sm-2 mb-sm-0">Select Duration for history check</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="select"
                       v-model="screening.previous_history_duration"
                       placeholder="Select Duration for history check"
                       :list="screeningDuration"
            />

          </div>
        </div>
      </template>
      <template slot="footer">
        <button
            type="button"
            class="btn btn-success mr-2"
            @click.prevent="updateScreening">
          {{ $t("Update Screening") }}
        </button>
        <button
            type="button"
            class="btn btn-secondary mr-2"
            data-dismiss="modal"
            @click="closeModal">
          {{ $t("Cancel") }}
        </button>
      </template>
    </app-modal>
  </template>

    <template v-if="confirmEmploymentModal">
      <app-modal
          :modal-id="confirmEmploymentModalId"
          modal-alignment="top"
          modal-size="default"
          @close-modal="closeModal(confirmEmploymentModalId)"
      >
        <template slot="header">
          <h5 class="modal-title">{{ isExistingEmployee ? $t("Assign Additional Forms") : $t("Add Applicant To Employment") }}</h5>
          <button
              type="button"
              class="close outline-none"
              data-dismiss="modal"
              aria-label="Close"
              @click="confirmEmploymentModal = false"
          >
            <span><app-icon :name="'x'"></app-icon></span>
          </button>
        </template>
        <template slot="body">
          <div v-if="fetchingForms" class="text-center p-5">
            <app-preloader />
          </div>
          <div v-else-if="screeningForms.length > 0">
            <p>{{ $t('The following forms/contracts will be assigned to the applicant:') }}</p>
            <ul class="list-group">
              <li v-for="form in screeningForms" :key="form.id" class="list-group-item d-flex align-items-center">
                <input
                  type="checkbox"
                  :value="form.form_revision_id"
                  v-model="selectedEmploymentForms"
                  :disabled="isFormAssigned(form)"
                  class="mr-3"
                  :style="{ width: '18px', height: '18px', cursor: isFormAssigned(form) ? 'not-allowed' : 'pointer' }"
                >
                <span :class="{ 'text-muted': isFormAssigned(form) }">{{ form.title }}</span>
                <span v-if="isFormAssigned(form)" class="badge badge-secondary ml-auto">{{ $t('Already assigned') }}</span>
              </li>
            </ul>
          </div>
          <div v-else class="text-center">
            <p class="text-danger">{{ $t('No employment forms found. Please add forms to employment contracts first then proceed next.') }}</p>
            <a href="/admin/documentlibrary/mydocument" class="btn btn-primary">{{ $t('Go to Document Library') }}</a>
          </div>
        </template>
        <template slot="footer">
          <button
              v-if="screeningForms.length > 0"
              type="button"
              class="btn btn-success mr-2"
              :disabled="selectableEmploymentForms.length === 0"
              @click.prevent="addApplicantToEmploymentConfirmed">
            {{ isExistingEmployee ? $t("Assign") : $t("Proceed") }}
          </button>
          <button
              type="button"
              class="btn btn-secondary mr-2"
              data-dismiss="modal"
              @click="closeModal(confirmEmploymentModalId)">
            {{ $t("Cancel") }}
          </button>
        </template>
      </app-modal>
    </template>
    
    <template v-if="downloadEmploymentContractsModal">
      <app-modal
          :modal-id="downloadEmploymentContractsModalId"
          modal-alignment="top"
          modal-size="default"
          @close-modal="closeModal(downloadEmploymentContractsModalId)"
      >
        <template slot="header">
          <h5 class="modal-title">{{ $t("Download Employment Forms") }}</h5>
          <button
              type="button"
              class="close outline-none"
              data-dismiss="modal"
              aria-label="Close"
              @click="downloadEmploymentContractsModal = false"
          >
            <span><app-icon :name="'x'"></app-icon></span>
          </button>
        </template>
        <template slot="body">
          <div v-if="fetchingForms" class="text-center p-5">
            <app-preloader />
          </div>
          <div v-else-if="screeningForms.length > 0" class="p-3">
            <table class="table table-borderless" style="width: 100%;">
              <thead>
                <tr style="border-bottom: 2px solid #e9ecef;">
                  <th style="padding: 12px; font-weight: 600; color: #000;">{{ $t('Form') }}</th>
                  <th style="padding: 12px; font-weight: 600; color: #000; text-align: center;">{{ $t('Status') }}</th>
                  <th style="padding: 12px; font-weight: 600; color: #000; text-align: center;">{{ $t('Reminder') }}</th>
                  <th style="padding: 12px; font-weight: 600; color: #000; text-align: center;">{{ $t('Counter Sign') }}</th>
                  <th style="padding: 12px; font-weight: 600; color: #000; text-align: center;">{{ $t('Download') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(form, index) in screeningForms" :key="form.id" :style="index % 2 === 0 ? 'background-color: #f8f9fa;' : 'background-color: #ffffff;'">
                  <td style="padding: 15px; vertical-align: middle;">
                    <a href="javascript:void(0)" @click="downloadContract(form)" style="font-size: 14px; color: #4e73df; font-weight: 500; text-decoration: none;" onmouseover="this.style.textDecoration='underline'" onmouseout="this.style.textDecoration='none'">
                      {{ form.title }}
                    </a>
                  </td>
                   <td style="padding: 15px; text-align: center; vertical-align: middle;">
                    <span style="font-size: 14px;" :style="{ color: (form.submission_status !== 'Not submitted' && form.submission_status !== 'not submitted') ? '#28a745' : '#6c757d', fontWeight: (form.submission_status !== 'Not submitted' && form.submission_status !== 'not submitted') ? '600' : '400' }">
                      {{ form.submission_status === 'Not submitted' ? $t('Not submitted') : $t($t(form.submission_status).charAt(0).toUpperCase() + $t(form.submission_status).slice(1)) }}
                    </span>
                  </td>
                  <td style="padding: 15px; text-align: center; vertical-align: middle;">
                    <button 
                      class="btn btn-warning" 
                      @click="sendReminderEmail(form)"
                      style="background-color: #ffc107; border: none; padding: 8px 20px; font-size: 14px; border-radius: 4px; color: #000; font-weight: 500;">
                      {{ $t('Reminder') }}
                    </button>
                  </td>
                  <td style="padding: 15px; text-align: center; vertical-align: middle;">
                    <button 
                      class="btn btn-primary ml-1" 
                      @click="counterSign(form)"
                      :style="{ backgroundColor: (form.submission_status === 'Not submitted' || form.submission_status === 'not submitted') ? '#b0c4de' : '#4e73df', border: 'none', padding: '8px 20px', fontSize: '14px', borderRadius: '4px', color: '#fff', fontWeight: '500', cursor: (form.submission_status === 'Not submitted' || form.submission_status === 'not submitted') ? 'not-allowed' : 'pointer' }">
                      {{ $t('Counter Sign') }}
                    </button>
                  </td>
                  <td style="padding: 15px; text-align: center; vertical-align: middle;">
                    <input 
                      type="checkbox" 
                      :id="'form-checkbox-' + form.id"
                      v-model="selectedForms"
                      :value="form.form_revision_id"
                      style="width: 20px; height: 20px; cursor: pointer;"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="text-center p-5 text-secondary">
            <p style="font-size: 16px;">{{ $t('No employment forms have been assigned to this applicant yet.') }}</p>
          </div>
        </template>
        <template slot="footer">
          <button
              v-if="screeningForms.length > 0"
              type="button"
              class="btn btn-success mr-2"
              @click="downloadSelectedForms">
            {{ $t("Download Report") }} ({{ selectedForms.length }})
          </button>
          <button
              type="button"
              class="btn btn-secondary mr-2"
              data-dismiss="modal"
              @click="closeModal(downloadEmploymentContractsModalId)">
            {{ $t("Close") }}
          </button>
        </template>
      </app-modal>
    </template>

    <task-endorse
        v-if="isTaskEndorseModalActive"
        modal-id="endorse-Modal"
        :taskId="endorseTaskId"
        :formData="endorseFormData"
        @close-modal="isTaskEndorseModalActive = false"
        @afterSubmitDone="downloadEmploymentContracts"
    />
  </div>

</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import {TableHelpers} from "../../Demo/Tables/mixins/TableHelpers";
import {ADD_TO_EMPLOYMENT, SCREENING_SCHEDULE, APPLICANT_ENDORSEMENT, GET_SCREENING_FORMS, GET_ASSIGNED_SCREENING_FORMS } from '../../../../Config/ScreeningAppUrl'
import {ModalMixin} from "@/app/Mixins/ModalMixin";
import {FormMixin} from "@/core/mixins/form/FormMixin";
import {Candidate} from "@Views/Screening/utility/apiAgent";
import {mergeDateTime} from "@Views/Screening/utility/common/candidate";
import {axiosGet} from "@/app/Helpers/AxiosHelper";
import {GET_COMPANY_USERS} from "@/app/Config/ApiUrl";

import {APPLICANT_FILES} from "@/app/Config/ScreeningAppUrl";
import * as actions from "@/app/Config/ApiUrl";
import {screeningDuration, screeningTypeList} from "@Views/Screening/utility/constant";
import AppLibrary from "../../../../Helpers/AppLibrary";


export default {
  extends: AppLibrary,
  name: "ScreeningInProgressCandidates",
  mixins: [TableHelpers, FormMixin, ModalMixin],
  props: {
    active: Number,
    customerCompany: {},
  },
  data() {
    return {
      pageTitle: this.getPageTitle(),
      id: 0,
      select_user: '',
      users: [],
      tableId: "in_progress_screening_table",
      rowData: {},
      screeningChecklists: [],
      localChecklists: [],
      screeningUpdateModalId: 'screening_update_modal',
      confirmEmploymentModalId: 'confirm_employment_modal',
      downloadEmploymentContractsModalId: 'download_employment_contracts_modal',
      screeningTypeList: screeningTypeList,
      screeningDuration: screeningDuration,
      screeningForms: [],
      selectedForms: [],
      assignedFormRevisionIds: [],
      isExistingEmployee: false,
      confirmEmploymentModal: false,
      downloadEmploymentContractsModal: false,
      fetchingForms: false,
      selectedEmploymentForms: [],

      options: {
        name: "AdvanceTable",
        url: SCREENING_SCHEDULE,
        showHeader: true,
        columns: [
          {
            title: this.$t("Applicant Id"),
            type: "custom-html",
            key: "id",
            sortable: true,
            modifier: (value, row) => {
              const baseId = 10000;
              const url = `/candidate-detail/${row.company_id}/${row.applicant_id}`;
              const applicantId = baseId + value;
              // Optional: Add company prefix or logic
              // e.g., if company_id = 3, you could show A03-10002
              const companyPrefix = row.company_id ? `C${String(row.company_id).padStart(2, '0')}-` : '';

              return `<a href="${url}" target="_blank"><span>${companyPrefix}${applicantId}</span></a>`;
            },
          },
          {
            title: this.$t("Employee Id"),
            type: "custom-html",
            key: "employee_id",
            sortable: true,
            modifier: (value, row) => {
              return `<span>${row.applicant?.user_id ?? '-'}</span>`;
            },
          },
          {
            title: this.$t("name"),
            type: "custom-html",
            key: "applicant",
            sortable: true,
            modifier: (value) => {
              return `<span>${this.$t(value.full_name)}</span>`;
            },
          },

          {
            title: this.$t("created_at"),
            type: "custom-html",
            key: "created_at",
            sortable: true,
            modifier: (value) => {
              var date = moment(value).format("DD-MM-YYYY");
              return `<span>${this.$t(date)}</span>`;
            },
          },
          {
            title: this.$t("Screening Progress"),
            type: "custom-html",
            key: "applicant",
            modifier: (value) => {
              return `<span data-toggle="tooltip" title="This represents the checks that applicant has passed.">
               ${value.completion_percentage ? `${value.completion_percentage}%` : ""}
                </span>`;

            },
          },
          {
            title: this.$t("start_date"),
            type: "custom-html",
            key: "start_date",
            sortable: true,
            modifier: (value) => {
              return `<span>${value}</span>`;
            },
          },
          {
            title: this.$t("to_be_completed_by"),
            type: "custom-html",
            key: "complete_screening_due_date",
            sortable: true,
            modifier: (value) => {
              if (value){
                const date1 = new Date(value);
                const date2 = new Date();
                // One day in milliseconds
                const oneDay = 1000 * 60 * 60 * 24;
                // Calculating the time difference between two dates
                const diffInTime = date1.getTime() - date2.getTime();
                // Calculating the no. of days between two dates
                const diffInDays = Math.round(diffInTime / oneDay);

                if (diffInDays <= 20 && diffInDays >= 11) {
                  return `<span class="badge badge-sm badge-pill badge-warning">${this.$t(
                      diffInDays+' Days left'
                  )}</span>`;

                }
                else if(diffInDays <= 10) {
                  if (diffInDays < 1) {
                    return `<span class="badge badge-sm badge-pill badge-danger">${this.$t(
                        'Due Date Passed'
                    )}</span>`;
                  }
                  else {
                    return `<span class="badge badge-sm badge-pill badge-danger">${this.$t(
                        diffInDays+' Days left'
                    )}</span>`;
                  }

                }
                else {
                  return `<span class="badge badge-sm badge-pill badge-success">${this.$t(
                      diffInDays+' Days left'
                  )}</span>`;
                }
              }else{
                return `<span class="badge badge-sm badge-pill badge-success">${this.$t(
                    'N/A'
                )}</span>`;
              }


            },
          },
          {
            title: this.$t("limited_screening_completed_by"),
            type: "custom-html",
            key: "limited_screening_due_date",
            sortable: true,
            modifier: (value) => {
              if (value){
                const date1 = new Date(value);
                const date2 = new Date();
                // One day in milliseconds
                const oneDay = 1000 * 60 * 60 * 24;
                // Calculating the time difference between two dates
                const diffInTime = date1.getTime() - date2.getTime();
                // Calculating the no. of days between two dates
                const diffInDays = Math.round(diffInTime / oneDay);

                if (diffInDays <= 20 && diffInDays >= 11) {
                  return `<span class="badge badge-sm badge-pill badge-warning">${this.$t(
                      diffInDays+' Days left'
                  )}</span>`;

                }
                else if(diffInDays <= 10) {
                  if (diffInDays < 1) {
                    return `<span class="badge badge-sm badge-pill badge-danger">${this.$t(
                        'Due Date Passed'
                    )}</span>`;
                  }
                  else {
                    return `<span class="badge badge-sm badge-pill badge-danger">${this.$t(
                        diffInDays+' Days left'
                    )}</span>`;
                  }

                }
                else {
                  return `<span class="badge badge-sm badge-pill badge-success">${this.$t(
                      diffInDays+' Days left'
                  )}</span>`;
                }
              }else{
                return `<span class="badge badge-sm badge-pill badge-success">${this.$t(
                    'N/A'
                )}</span>`;
              }


            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("Screening Type"),
            type: "custom-html",
            key: "screening_type",
            modifier: (value) => {
              return `<span>${this.$t(value??'Internal')}</span>`;
            },
          },
          {
            title: this.$t("Applicant Endorsement"),
            type: "custom-html",
            key: "screening_endorsement",
            modifier: (value) => {

              return `<span>${this.$t(value[0]?.status??"Not Requested")}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
            color: "#4A90E2", // Blue
          },{
            title: this.$t("update_screening"),
            icon: "edit-3",
            type: "none",
            color: "#F5A623", // Orange
          },
          {
            title: this.$t("assign_to_user"),
            icon: "user",
            type: "none",
            color: "#9013FE", // Purple
          },
          {
            title: this.$t("download_full_screening_report"),
            icon: "download",
            type: "none",
            color: "#7ED321", // Green
          },
          {
            title: this.$t("download_application_form"),
            icon: "download-cloud",
            type: "none",
            color: "#50E3C2", // Teal
          },
          {
            title: this.$t("download_employment_contracts"),
            icon: "arrow-down-circle",
            type: "none",
            color: "#417505", // Dark Green
          },
          {
            title: this.$t("add_applicant_to_employment"),
            icon: "plus",
            type: "none",
            color: "#00BFFF", // Cyan
            modifier: (row) => !row.applicant?.user_id,
          },
          {
            title: this.$t("assign_additional_forms"),
            icon: "file-text",
            type: "none",
            color: "#00BFFF", // Cyan
            modifier: (row) => !!row.applicant?.user_id,
          },
          {
            title: this.$t("request_applicant_endorsement"),
            icon: "check-circle",
            type: "none",
            color: "#FF1493", // Pink
          },
        ],
        filters: [
          { key: 'complete_screening_due_date', title: this.$t('to_be_completed_by'), type: 'range-picker', initValue: '' },
          { key: 'limited_screening_due_date', title: this.$t('limited_screening_completed_by'), type: 'range-picker', initValue: '' },
          { key: 'start_date', title: this.$t('start_date'), type: 'range-picker', initValue: '' },
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 30,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
      modalId: "vetting_complete_modal",
      vettingCompleteModalShow: false,
      assignToDirectorModalId: "assign_to_director",
      assignToUserModalId: "assign_to_user_modal",
      assignToDirectorModal: false,
      assignToUserModal: false,
      screeningCheckPointModal: false,

      applicantFiles: [],
      screeningUpdateModal: false,
      screening: {},
      isTaskEndorseModalActive: false,
      endorseTaskId: 0,
      endorseFormData: {},

    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.getUsers();
  },
  methods: {
    updateScreening(){
      const createdAt = this.getDateFormatForBackend(this.screening.created_at.toString());
      const startDate = this.getDateFormatForBackend(this.screening.start_date.toString());
      const DeploymentDate = this.getDateFormatForBackend(this.screening.deployment_date);
      const limitedScreeningDate = this.getDateFormatForBackend(this.screening.limited_screening_due_date);

      if (moment(startDate).isBefore(moment(createdAt))) {
        this.$toastr.e(this.$t("Screening date cannot be before creation date"));
        return;
      }

      if (moment(DeploymentDate).isBefore(moment(createdAt))) {
        this.$toastr.e(this.$t("Deployment date cannot be before screening creation date"));
        return;
      }

      if (moment(limitedScreeningDate).isBefore(moment(createdAt))) {
        this.$toastr.e(this.$t("Limited screening date cannot be before screening creation date"));
        return;
      }

      const body = {
        applicant_id: this.rowData.applicant_id,
        id: this.rowData.id,
        created_at: createdAt,
        start_date: startDate,
        deployment_date: DeploymentDate,
        limited_screening_due_date: limitedScreeningDate,
        company_id: this.rowData.company_id,
        previous_history_duration: this.screening.previous_history_duration,
      };
      Candidate.postScreeningSchedule(body)
          .then(({data}) => {
            this.$toastr.s(data.message);
          })
          .finally(() => {
            this.closeModal(this.screeningUpdateModalId);
            this.$hub.$emit('reload-' + this.tableId);
          });
    },
    mergeDateTime,
    getPageTitle() {
      let pageTitle = 'Candidates Screening In Progress';
      let customerCompany = this.customerCompany;
      if (customerCompany) {
        pageTitle = 'Screening For ' + customerCompany.company_name;
      }
      return pageTitle;
    },
    getUsers() {
      axiosGet(GET_COMPANY_USERS)
          .then((res) => {
            this.users = res.data;
          })
          .catch((error) => {

          });
    },
    assignToUser(){
      const body = {
        assigned_to: this.select_user,
        status: 'forwarded_to_user'
      };
      Candidate.postVetting(this.rowData.id, body)
          .then((res) => {
            this.$toastr.s(res.data.message);
          })
          .catch((error) => {
            console.error(error);
            this.$toastr.s(error.data.message);

          })
          .finally(() => {
            this.closeModal(this.assignToUserModalId);
          });

    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      this.screening = rowData;
      if (actionObj.title == this.$t("view")) {
        window.open(`/candidate-detail/${rowData.company_id}/${rowData.applicant_id}`, '_blank');
      } else if (actionObj.title == this.$t("update_screening")) {
        this.screeningUpdateModal = true;
      }
      else if (actionObj.title == this.$t("download_full_screening_report")) {
        window.open('/generate-candidate-screening-report/full_screening?applicant_id='+rowData.applicant_id, '_blank');
      }else if (actionObj.title == this.$t("download_application_form")) {
        window.open('/generate-candidate-screening-report/applicationForm?applicant_id='+rowData.applicant_id, '_blank');
      }
      else if (actionObj.title == this.$t("download_limited_screening_report")) {
        window.open('/generate-candidate-screening-report/limited_screening?applicant_id='+rowData.applicant_id, '_blank');
      }else if (actionObj.title == this.$t("assign_to_user")) {
        this.assignToUserModal = true;
      }else if (actionObj.title == this.$t("add_applicant_to_employment") || actionObj.title == this.$t("assign_additional_forms")) {
        this.fetchScreeningForms();
      }else if (actionObj.title == this.$t("download_employment_contracts")) {
        this.downloadEmploymentContracts();
      }else if (actionObj.title == this.$t("request_applicant_endorsement")) {
        this.requestApplicantEndorsement();
      }
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    addApplicantToEmployment(){
      this.fetchScreeningForms();
    },
    isFormAssigned(form) {
      return this.assignedFormRevisionIds.includes(form.form_revision_id);
    },
    fetchScreeningForms() {
      this.fetchingForms = true;
      this.confirmEmploymentModal = true;
      this.assignedFormRevisionIds = [];
      this.isExistingEmployee = !!this.rowData.applicant?.user_id;

      // For an already-converted employee, also fetch the forms already on their
      // screening task so we can disable them and only assign the new ones.
      const assignedRequest = this.isExistingEmployee
          ? axiosGet(GET_ASSIGNED_SCREENING_FORMS + '?applicant_id=' + this.rowData.applicant_id)
          : Promise.resolve({ data: { forms: [] } });

      Promise.all([axiosGet(GET_SCREENING_FORMS), assignedRequest])
          .then(([formsRes, assignedRes]) => {
            this.screeningForms = formsRes.data;
            this.assignedFormRevisionIds = (assignedRes.data.forms || []).map(form => form.form_revision_id);
            // Select all forms that are not already assigned by default
            this.selectedEmploymentForms = this.screeningForms
                .filter(form => !this.isFormAssigned(form))
                .map(form => form.form_revision_id);
          })
          .catch((error) => {
            console.error(error);
            const message = error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : "Failed to fetch screening forms.";
            this.$toastr.e(message);
          })
          .finally(() => {
            this.fetchingForms = false;
          });
    },
    downloadEmploymentContracts() {
      this.selectedForms = [];
      this.fetchingForms = true;
      this.downloadEmploymentContractsModal = true;
      axiosGet(GET_ASSIGNED_SCREENING_FORMS + '?applicant_id=' + this.rowData.applicant_id)
          .then(({data}) => {
            this.screeningForms = data.forms;
          })
          .catch((error) => {
            console.error(error);
            const message = error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : "Failed to fetch screening forms.";
            this.$toastr.e(message);
          })
          .finally(() => {
            this.fetchingForms = false;
          });
    },
    downloadContract(form) {
      window.open(`/generate-candidate-screening-report/single_form?applicant_id=${this.rowData.applicant_id}&form_revision_id=${form.form_revision_id}`, '_blank');
    },
    sendReminderEmail(form) {
      const applicantName = this.rowData.applicant?.full_name || 'Applicant';
      this.$toastr.s(this.$t('Reminder email being sent to ') + applicantName);
      
      const payload = {
        url: APPLICANT_ENDORSEMENT,
        data: {
          id: this.rowData.id,
          message: `Dear ${applicantName},\n\nThis is a reminder to submit the following form: ${form.title}\n\nPlease complete and submit this form as soon as possible.\n\nThank you.`
        },
      }
      this.axiosPost(payload)
      .then((response) => {
        // Success
      }).catch((err) => {
        this.$toastr.e(err.response?.data?.message || 'Failed to send reminder email');
      });
    },
    counterSign(form) {
      if (form.submission_status === 'Not submitted' || form.submission_status === 'not submitted') {
        this.$toastr.e(this.$t('Please submit the form first.'));
        return;
      }
      if (!form.task_id) {
        this.$toastr.e(this.$t('This form is not assigned to a task. Cannot counter-sign.'));
        return;
      }

      if (form.is_counter_signed) {
        if (!confirm(this.$t('A counter-signature already exists. Do you want to update it?'))) {
          return;
        }
      }

      this.closeModal(this.downloadEmploymentContractsModalId);

      this.endorseTaskId = form.task_id;
      this.endorseFormData = {
        ...form,
        task_id: form.task_id,
        form_id: form.form_revision_id,
        applicant_id: this.rowData.applicant_id,
        company_id: this.rowData.company_id,
        user_id: this.rowData.applicant?.user_id
      };
      this.isTaskEndorseModalActive = true;
    },
    downloadSelectedForms() {
      if (this.selectedForms.length === 0) {
        this.$toastr.w(this.$t('Please select at least one form to download'));
        return;
      }

      // Check if any selected form is not submitted
      const hasNonSubmittedSelected = this.screeningForms.some(form => 
        this.selectedForms.includes(form.form_revision_id) && 
        (form.submission_status === 'Not submitted' || form.submission_status === 'not submitted')
      );

      // Determine which forms to download
      let formsToDownload = this.selectedForms;

      // Show confirmation if non-submitted forms are selected
      if (hasNonSubmittedSelected) {
        const confirmed = window.confirm(this.$t('Are you sure you want to download? Some forms are not submitted yet and will show empty templates.'));
        
        if (!confirmed) {
          // User clicked No/Cancel - download only submitted forms
          formsToDownload = this.screeningForms
            .filter(form => 
              this.selectedForms.includes(form.form_revision_id) && 
              form.submission_status !== 'Not submitted' && 
              form.submission_status !== 'not submitted'
            )
            .map(form => form.form_revision_id);
          
          // Check if there are any submitted forms left
          if (formsToDownload.length === 0) {
            this.$toastr.w(this.$t('No submitted forms selected. Please submit the forms first.'));
            return;
          }
        }
      }

      // Generate single combined report with selected forms
      const formRevisionIds = formsToDownload.join(',');
      window.open(`/generate-candidate-screening-report/single_form?applicant_id=${this.rowData.applicant_id}&form_revision_id=${formRevisionIds}`, '_blank');
      
      // Clear selections and close modal after download
      setTimeout(() => {
        this.selectedForms = [];
        this.closeModal(this.downloadEmploymentContractsModalId);
      }, 1000);
    },
    addApplicantToEmploymentConfirmed(){
      // Never resend forms that are already assigned to the employee's task.
      const formsToAssign = this.selectedEmploymentForms.filter(
          id => !this.assignedFormRevisionIds.includes(id)
      );
      if (formsToAssign.length === 0) {
        this.$toastr.w(this.$t('Please select at least one form to assign'));
        return;
      }
      const payload = {
        url: ADD_TO_EMPLOYMENT,
        data: {
          ...this.rowData,
          selected_forms: formsToAssign
        },
      }
      this.axiosPost(payload)
      .then((response) => {
        this.$toastr.s(response.data.message)
        this.$hub.$emit('reload-' + this.tableId);
      }).catch((err) => {

        this.$toastr.e(err.response.data.message);
      }).finally(() => {
        this.closeModal(this.confirmEmploymentModalId);
      })
    },
    requestApplicantEndorsement(){
      const applicantName = this.rowData.applicant?.full_name || 'Applicant';
      this.$toastr.s(this.$t('Endorsement Request being sent to ') + applicantName);
      
      this.downloadEmploymentContractsModal = false;
      this.closeModal(this.downloadEmploymentContractsModalId);

      const payload = {
        url: APPLICANT_ENDORSEMENT,
        data: {
          id:this.rowData.id,
          message: this.notificationMessage
        },
      }
      this.axiosPost(payload)
      .then((response) => {
        // Success handled instantly above for better UX
      }).catch((err) => {
        this.$toastr.e(err.response.data.message);
      }).finally(() => {
        this.$hub.$emit('reload-' + this.tableId);
      });
    },
    closeModal(modalId) {
      $(`#${modalId}`).modal('hide');
      this.vettingCompleteModalShow = false;
      this.screeningCheckPointModal = false;
      this.assignToUserModal = false;
      this.assignToDirectorModal = false;
      this.screeningUpdateModal = false;
      this.confirmEmploymentModal = false;
      this.downloadEmploymentContractsModal = false;

    },
  },
  computed:{
    today(){
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, '0');
      const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
      const yyyy = today.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
    },
    selectableEmploymentForms(){
      return this.screeningForms.filter(form => !this.isFormAssigned(form));
    }
  },
  watch: {

  },

};
</script>
<style scoped>
.checklist-item {
  width: 48%;  /* Each item takes half of the row */
  min-width: 300px; /* Ensures proper form width */
  margin-right: 2%;
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .checklist-item {
    width: 100%; /* Stacks items on smaller screens */
    margin-right: 0;
  }
}

</style>